import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginPageComponent } from './login-page/login-page.component';

const routes: Routes = [
  {
    path: '',
    component: LoginPageComponent,
    data: {
      meta: {
        title: 'Login | Unidrogas S.A.S.',
        description:
          'Pantalla de inicio de sesión para usuarios tipo cliente, proveedor, bodega y área de compras.',
      },
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoginRoutingModule {}
